import Home from "./home/home";
import Login from "./login/login";
const pages = {
  Home,
  Login
};
export default pages;
